import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { AggregatesIncidentsBlock } from "./ui/AggregatesIncidentsBlock";
import { AggregatesIncidentsBlockState } from "./state";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
// import * as MOCKSTYPE from "../../mocks";
// let _: typeof MOCKSTYPE;
// let AggregatesDataMock;
if (process.env.NODE_ENV === "development") {
    // _ = require("../../mocks");
    // AggregatesDataMock = _.AggregatesDataMock;
}
export class AggregatesIncidentsBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new AggregatesIncidentsBlockState(internalMessageBus);
            //export data store to window for debug purposes
            window["AggregatesIncidentsBlockState"] = this.dataProvider;
            // window["AggregatesIncidentsDataMock"] = new AggregatesDataMock(internalMessageBus);
            // window["AggregatesIncidentsDataMock"].activate();
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use dataProvider - internalMessageBus passed during the construction from the
            // mobile application page method
            this.dataProvider = new AggregatesIncidentsBlockState(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        this.dataProvider.activate();
        return super.activate(React.createElement(AggregatesIncidentsBlock, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
    deactivate() {
        this.dataProvider.deactivate();
        // if (process.env.NODE_ENV === "development") {
        //     window["AggregatesIncidentsDataMock"].deactivate();
        // }
        return super.deactivate();
    }
}
window["AggregatesIncidentsBlock"] = AggregatesIncidentsBlockRoot;
broadcastBlockLoad("AggregatesIncidentsBlock");
//# sourceMappingURL=index.js.map